
import { defineComponent, PropType, Ref } from "vue"

export default defineComponent({
  props: {
    play: { type: Function, required: true },
    isPosterVisible: {
      type: Object as PropType<Ref<Boolean>>,
      required: true
    },
    totalDuration: { type: String, required: false }
  }
})
